import * as React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

interface IProps extends ICellRendererParams {
    onValueChange: (id: number, isChecked: boolean, centerId: number, organType: number) => void
}

class CheckboxRendererInvoice extends React.Component<IProps, {}> {
    checkedHandler = (e: React.FormEvent<HTMLInputElement>) => {
        let checked = e.currentTarget.checked;
        let colId = this.props.column.getColId();
        this.props.node.setDataValue(colId, checked);

        let data = this.props.data;

        this.props.onValueChange(
            data.id != null ? parseInt(data.id) : null,
            checked,
            data.centerId,
            data.organType
        );
    }

    render = () => {
        let data = this.props.node.data;

        if (data.id != null || data.centerId > 0)
            return (
                <input
                    type='checkbox'
                    onClick={this.checkedHandler}
                    checked={this.props.value}
                />
            );

        return null;
    }
}

export default CheckboxRendererInvoice;